import qs from "qs";
import Cookies from "js-cookie";

import config from "../../config";
import { getAll } from "./MarketingParamsStorage";

const COOKIE_TO_HEADER_FIELD = {
  _ttp: "ttp",
  _fbc: "fbc",
  _fbp: "fbp"
};

export default function getMarketingParamsRequestHeader(
  marketingParamsConfig = config.marketingParams
) {
  if (!marketingParamsConfig?.requestHeaderName) {
    return null;
  }

  const params = getAll();

  const flatStoredParams = Object.fromEntries(
    Object.entries(params)
      .filter(([, entry]) => {
        const value = entry?.value;

        return value && typeof value === "string";
      })
      .map(([name, { value }]) => [name, value])
  );

  const cookieParams = Object.fromEntries(
    Object.entries(COOKIE_TO_HEADER_FIELD)
      .map(([cookieName, headerFieldName]) => [headerFieldName, Cookies.get(cookieName)])
      .filter(([, value]) => value && typeof value === "string")
  );

  const flatParams = {
    ...flatStoredParams,
    ...cookieParams
  };

  const headerValue = qs.stringify(flatParams);

  if (!headerValue) {
    return null;
  }

  return {
    headerName: marketingParamsConfig.requestHeaderName,
    headerValue
  };
}
